export const aceModal = () => {
    var aceModalTrigger = document.getElementsByClassName('js-modal-trigger');
    var aceModalClose = document.getElementsByClassName('js-modal-close');
    
    if (aceModalTrigger != null) {
        [].forEach.call(aceModalTrigger, function (aceModalTriggerSingle) {
            aceModalTriggerSingle.addEventListener('click', function () {
                aceModalTriggerEvent(aceModalTriggerSingle);
            });
        });
    }
    if (aceModalClose != null) {
        [].forEach.call(aceModalClose, function (aceModalCloseSingle) {
            aceModalCloseSingle.addEventListener('click', function () {
                aceModalCloseEvent(aceModalCloseSingle);
            });

            aceModalCloseSingle.addEventListener('keyup', function (e) {
                if (e.keyCode === 13) {
                    aceModalCloseEvent(aceModalCloseSingle);
                }
            });
        });
    }
}

const aceModalTriggerEvent = (aceTrigger: Element) => {
    var aceModal = document.getElementById(aceTrigger.getAttribute('aria-controls'));

    if (aceTrigger.getAttribute('aria-expanded') == 'false') {
        aceTrigger.setAttribute('aria-expanded', 'true');
        aceModal.classList.add('active');
        aceModal.setAttribute('aria-hidden', 'false');
        aceModal.setAttribute('aria-expanded', 'true');
    }
}

const aceModalCloseEvent = (aceClose: Element) => {
    var aceModal = document.getElementById(aceClose.getAttribute('data-close'));
    var aceTrigger = document.querySelectorAll('[aria-controls="' + aceClose.getAttribute('data-close') + '"]')[0];

    if (aceModal.getAttribute('aria-expanded') == 'true') {
        aceTrigger.setAttribute('aria-expanded', 'false');
        aceModal.classList.remove('active');
        aceModal.setAttribute('aria-hidden', 'true');
        aceModal.setAttribute('aria-expanded', 'hidden');
    }

}